import CRMauth from "@/services/CRMinitAuth";

const list = query =>
  CRMauth.get(`${process.env.VUE_APP_CRM_API}common/course_leaders/`, {
    params: query
  });

const create = data =>
  CRMauth.post(`${process.env.VUE_APP_CRM_API}common/course_leaders/`, data);

const update = data =>
  CRMauth.patch(`${process.env.VUE_APP_CRM_API}common/course_leaders/${data.id}/`, data);


export default {
  list,
  create,
  update
};

